import { defineMessages } from 'react-intl';

export const JobMessages = defineMessages({
  successfulJobUpload: {
    id: 'JobList.successfulJobUpload',
    defaultMessage: 'Success! Job log was transferred from the controller and is uploading in the background.',
  },
  errorJobUpload: {
    id: 'JobList.errorJobUpload',
    defaultMessage: 'Error uploading file. Please try again.',
  },
  uploadJobModalHeader: {
    id: 'JobList.uploadJobModalHeader',
    defaultMessage: 'Upload a Job',
    description: 'Header for job upload form.',
  },
  uploadJobButtonLabel: {
    id: 'JobList.uploadJobButtonLabel',
    defaultMessage: 'Upload Job',
  },
  jobDetailsFormTitle: {
    id: 'Jobs.jobDetailsFormTitle',
    defaultMessage: 'Update Job Details',
  },
  jobLogsTitle: {
    id: 'JobList.jobLogsTitle',
    defaultMessage: 'Job Logs',
  },
  liveJobsTitle: {
    id: 'JobList.liveJobsTitle',
    defaultMessage: 'Live Jobs',
  },
  noJobsRecordedMessage: {
    id: 'JobList.noJobsRecordedMessage',
    defaultMessage: 'No Jobs have been recorded yet',
  },
  noJobsFoundMessage: {
    id: 'JobList.noJobsFoundMessage',
    defaultMessage: 'No Jobs have been recorded yet',
  },
  jobInfoAddAnnotationPlaceholder: {
    id: 'JobInfo.addAnnotation',
    defaultMessage: 'Add a comment...',
    description: 'Placeholder for an add comment control.',
  },
  jobInfoAnnotationsHeader: {
    id: 'JobInfo.annotationsHeader',
    defaultMessage: 'Comments',
    description: 'Header for comment section',
  },
  jobInfoDeleteAnnotationConfirmation: {
    id: 'JobInfo.deleteAnnotationConfirmation',
    defaultMessage: 'Are you sure you want to delete this comment?',
  },
  jobInfoUpdateAnnotation: {
    id: 'JobInfo.updateComment',
    defaultMessage: 'Update comment',
  },
  jobCountSharedJobLogs: {
    id: 'JobsCountCard.sharedJobLogs',
    defaultMessage: 'Shared Job Logs',
  },
  jobCountUploadedJobLogs: {
    id: 'JobsCountCard.uploadedJobLogs',
    defaultMessage: 'Uploaded Job Logs',
  },
  jobInProgressJobLogs: {
    id: 'InProgressJobsCountCard.inProgressJobLogs',
    defaultMessage: 'Jobs In Progress',
  },
  lastJobCardMostRecentShared: {
    id: 'LastJobCard.mostRecentSharedJobLog',
    defaultMessage: 'Most Recent Shared Job Log',
  },
  lastJobCardLastUploadedJob: {
    id: 'LastJobCard.lastUploadedJobLog',
    defaultMessage: 'Last Uploaded Job Log',
  },
  lastJobCardLogNotUploaded: {
    id: 'LastJobCard.haveNotUploadedJob',
    defaultMessage: 'You have not yet uploaded a job log!',
  },
  recentActivityNoJobsRecorded: {
    id: 'Jobs.recentActivityNoJobsRecorded',
    defaultMessage: 'No jobs have been recorded yet.',
  },
  tubesCleanedLabel: {
    id: 'TubesCleanedGraph.tubesCleanedLabel',
    defaultMessage: 'Tubes Cleaned',
    description: 'A label for the total number of tubes on a heat exchanger that are cleaned',
  },
  autoStrokesOccurredLabel: {
    id: 'TubesCleanedGraph.autoStrokesOccurredLabel',
    defaultMessage: 'Autostrokes occurred',
  },
  autoStrokesDidNotOccurredLabel: {
    id: 'TubesCleanedGraph.autoStrokesDidNotOccurredLabel',
    defaultMessage: 'Autostrokes did not occur',
  },
  cleanedLabel: {
    id: 'TubesCleanedGraph.cleanedLabel',
    defaultMessage: 'Cleaned',
    description: 'A label for the number of tubes that are cleaned',
  },
  tubesPartiallyCleanedLabel: {
    id: 'TubesCleanedGraph.tubesPartiallyCleaned',
    defaultMessage: 'Tubes Partially Cleaned',
    description: 'A label for the total number of tubes on a heat exchanger that are partially cleaned.',
  },
  uncleanedLabel: {
    id: 'TubesCleanedGraph.uncleanedLabel',
    defaultMessage: 'Uncleaned',
    description: 'A label for the number of tubes that are unclean',
  },
  commentLabel: {
    id: 'TubesCleanedGraph.commentLabel',
    defaultMessage: 'Comment',
    description: 'A label for a comment left by a user',
  },
  tubeSheetHeatMapTitle: {
    id: 'TubeSheetHeatMap.title',
    defaultMessage: 'Time in Tube',
    description:
      'Title of a dot plot chart heat chart that displays the cross section of a heat exchanger. Each "dot" represents a tube, and the color represents the time range in that tube.',
  },
  tubeSheetTitle: {
    id: 'TubeSheet.title',
    defaultMessage: 'Completed Tubes',
    description:
      'Title of a dot plot chart that displays the cross section of a heat exchanger. Each "dot" represents a tube.',
  },
  tubeSheetDepthTitle: {
    id: 'TubeSheet.depthTitle',
    defaultMessage: 'Depth Cleaned',
  },
  tubeSheetAutoStrokesTitle: {
    id: 'TubeSheet.autoStrokesTitle',
    defaultMessage: 'Autostrokes',
  },
  tubeSheetAutoStrokesLabel: {
    id: 'TubeSheet.autoStrokesLabel',
    defaultMessage: 'Autostrokes',
    description: 'Label for the number of autostroke events that occurred during the cleaning of a heat exchanger.',
  },
  tubeSheetLanceSpeedTitle: {
    id: 'TubeSheet.tubeSheetLanceSpeedTitle',
    defaultMessage: 'Lance Speed',
  },
  tubeSheetDepthTooltip: {
    id: 'TubeSheet.depthTooltip',
    defaultMessage: 'Depth Cleaned: {value} {unit}',
    description:
      'Depth cleaned with, {value} and {unit} as variables provided by code. DO NOT translate {value} or {unit}.',
  },
  tubeSheetLanceSpeedTooltip: {
    id: 'TubeSheet.lanceSpeedTooltip',
    defaultMessage: 'Lance Speed: {value} {unit}',
    description:
      'Lance speed with, {value} and {unit} as variables provided by code. DO NOT translate {value} or {unit}.',
  },
  tubeSheetAutoStrokeTooltip: {
    id: 'TubeSheet.autoStrokeTooltip',
    defaultMessage: 'AutoStroke: {value}',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  uploadFormLogFileLabel: {
    id: 'UploadForm.logFileLabel',
    defaultMessage: 'Log File',
  },
  uploadFormSelectLogPlaceholder: {
    id: 'UploadForm.selectLogPlaceholder',
    defaultMessage: 'Select a Log File',
  },
  uploadFormSiteNameLabel: {
    id: 'UploadForm.siteNameLabel',
    defaultMessage: 'Site Name',
  },
  uploadFormSiteNamePlaceholder: {
    id: 'UploadForm.siteNamePlaceholder',
    defaultMessage: 'Add a name...',
  },
  uploadFormDescriptionLabel: {
    id: 'UploadForm.descriptionLabel',
    defaultMessage: 'Description',
  },
  uploadFormTagLabel: {
    id: 'UploadForm.tagLabel',
    defaultMessage: 'Tag',
  },
  uploadFormTagSearchModalTitle: {
    id: 'UploadForm.tagSearchModalTitle',
    defaultMessage: 'Tags',
  },
  uploadFormDescriptionPlaceholder: {
    id: 'UploadForm.descriptionPlaceholder',
    defaultMessage: 'Add a description...',
  },
  uploadFormHXModelNumberLabel: {
    id: 'UploadForm.hxModelNumberLabel',
    defaultMessage: 'HX Model Number',
  },
  uploadFormHXModelNumberPlaceholder: {
    id: 'UploadForm.hxPlaceHolder',
    defaultMessage: 'Add a model number...',
  },
  uploadFormTimeZoneLabel: {
    id: 'UploadForm.timeZoneLabel',
    defaultMessage: 'Time Zone',
  },
  searchOrAddNewTagPlaceholder: {
    id: 'UploadForm.searchOrAddNewTagPlaceholder',
    defaultMessage: 'Search or add a new tag',
  },
  logsTableIdColumn: {
    id: 'LogsTable.IdColumn',
    defaultMessage: 'Id',
    description: "Table column header for job log's unique identifier",
  },
  logsTableDeviceTimezoneColumn: {
    id: 'LogsTable.deviceTimezoneColumn',
    defaultMessage: 'Device Time Zone',
  },
  logsTableJobStartedDateColumn: {
    id: 'LogsTable.jobStartedDateColumn',
    defaultMessage: 'Job Started Date',
  },
  logsTableUploadDateColumn: {
    id: 'LogsTable.uploadDateColumn',
    defaultMessage: 'Upload Date',
  },
  logsTableSizeColumn: {
    id: 'LogsTable.sizeColumn',
    defaultMessage: 'Size (# of lines)',
    description: 'Column representing the number of lines in the log file of a job.',
  },
  logsTableSharedColumn: {
    id: 'LogsTable.sharedColumn',
    defaultMessage: 'Shared',
    description: 'Column representing whether a job log is shared or not.',
  },
  logsTableEmptyResults: {
    id: 'LogsTable.emptyResults',
    defaultMessage: 'Sorry, there are no matching job logs to display',
  },
  jobSystemInfoTitle: {
    id: 'JobSystemInfo.title',
    defaultMessage: 'This pie chart shows actuation the system was doing over the course of a job.',
  },
  jobSystemInfoPositioning: {
    id: 'JobSystemInfo.positioning',
    defaultMessage: 'Positioning - When the tractor is actively moving on the rails',
  },
  jobSystemInfoLanceFeeding: {
    id: 'JobSystemInfo.lanceFeeding',
    defaultMessage: 'Lance Feeding - The time the lances are actively being fed in and out',
  },
  jobSystemInfoControllerOff: {
    id: 'JobSystemInfo.controllerOff',
    defaultMessage: 'Controller Off - The time that the controller was off and not logging data.',
  },
  jobSystemInfoIdle: {
    id: 'JobSystemInfo.idle',
    defaultMessage: 'Idle - any time the controller was on, but not positioning or feeding.',
  },
  jobSystemInfoControllerOffTimes: {
    id: 'JobSystemInfo.controllerOffTimes',
    defaultMessage: 'Long controller off times',
  },
  jobSystemInfoControllerOffTimesDescription: {
    id: 'JobSystemInfo.controllerOffTimesDescription',
    defaultMessage: `Long controller off times can be a result of running the same 'job' over the course of multiple
    days or exchangers. Always be sure to start a new job for each exchanger and upload job logs in a timely
    manner`,
  },
  jobSystemInfoLongIdleTimes: {
    id: 'JobSystemInfo.longIdleTimes',
    defaultMessage: 'Long idle times',
  },
  jobSystemInfoLongIdleTimesDescription: {
    id: 'JobSystemInfo.longIdleTimesDescriptions',
    defaultMessage: `This category can mean a number of things happened during the job, including setup, breakdown, nozzle
    switches, tractor re-positioning, and other troubleshooting. Consider taking notes of when these activities
    happen to get a better breakdown of idle time usage.`,
  },
  endDate: {
    id: 'JobsModal.endDate',
    defaultMessage: `End date`,
  },
  startDate: {
    id: 'JobsModal.startDate',
    defaultMessage: `Start date`,
  },
  organization: {
    id: 'JobsModal.organization',
    defaultMessage: 'Organization',
  },
  controller: {
    id: 'JobsModal.controller',
    defaultMessage: 'Controller',
  },
  filterJobs: {
    id: 'JobsModal.filterJobs',
    defaultMessage: 'Filter jobs',
  },
  controllers: {
    id: 'JobsModal.controllers',
    defaultMessage: 'Controllers',
  },
  tubesOverTimeHeading: {
    id: 'JobDetailsInfo.tubesOverTimeHeading',
    defaultMessage: 'Tubes Over Time',
  },
  gotItButton: {
    id: 'JobDetailsInfo.gotItButton',
    defaultMessage: 'Got it',
  },
  tubesOverTimeDescription: {
    id: 'JobDetailsInfo.tubesOverTimeDescription',
    defaultMessage:
      'This chart shows the number of cleaned tubes, and partially cleaned tubes over the course of the job/time range.',
  },
  tubesOverTimeDescriptionBulletOne: {
    id: 'JobDetailsInfo.tubesOverTimeDescriptionBulletOne',
    defaultMessage: 'You can verify that all tubes were cleaned.',
  },
  tubesOverTimeDescriptionBulletTwo: {
    id: 'JobDetailsInfo.tubesOverTimeDescriptionBulletTwo',
    defaultMessage: 'You can see when the Sentinel was actively cleaning.',
  },
  overviewHeading: {
    id: 'JobDetailsInfo.overviewHeading',
    defaultMessage: 'Overview',
  },
  additionalDetailsHeading: {
    id: 'JobDetailsInfo.additionalDetailsHeading',
    defaultMessage: 'Additional Details',
  },
  tubeStatusHeading: {
    id: 'JobDetailsInfo.tubeStatusHeading',
    defaultMessage: 'Tube Statuses',
  },
  tubeStatusDetails: {
    id: 'JobDetailsInfo.tubeStatusDetails',
    defaultMessage:
      'To see additional details, hover over a tube with your mouse (desktop) or tap on a tube (mobile) to reveal additional details, including depth cleaned and autostroke time.',
  },
  tubeStatusKeyDetails: {
    id: 'JobDetailsInfo.tubeStatusKeyDetails',
    defaultMessage: 'The Completed Tubes graph displays the following statuses',
  },
  statusBlocked: {
    id: 'JobList.tubeSheetStatusBlocked',
    defaultMessage: 'Blocked',
  },
  statusNotCleaned: {
    id: 'JobList.tubeSheetNotCleaned',
    defaultMessage: 'Not Cleaned',
  },
  statusCleaned: {
    id: 'JobList.tubeSheetStatusCleaned',
    defaultMessage: 'Cleaned',
  },
  statusSkipped: {
    id: 'JobList.tubeSheetStatusSkipped',
    defaultMessage: 'Skipped',
  },
  statusNone: {
    id: 'JobList.tubeSheetStatusNone',
    defaultMessage: 'None',
  },
  statusAutostroke: {
    id: 'JobList.tubeSheetStatusAutostroke',
    defaultMessage: 'Autostroke',
  },
  zoomHeading: {
    id: 'JobDetailsInfo.zoomingHeading',
    defaultMessage: 'Zooming',
  },
  zoomSubHeading: {
    id: 'JobDetailsInfo.zoomingSubHeading',
    defaultMessage: 'You can zoom in and out of the graph using your keyboard or touchscreen',
  },
  zoomInstructionsBulletOne: {
    id: 'JobDetailsInfo.zoomInstructionsBulletOne',
    defaultMessage: 'In a browser, Ctrl and +/- or Ctrl and scroll wheel',
  },
  zoomInstructionsBulletTwo: {
    id: 'JobDetailsInfo.zoomInstructionsBulletTwo',
    defaultMessage: 'On a mobile or touchpad device, pinch to zoom in and out',
  },
  zoomInstructionsBulletThree: {
    id: 'JobDetailsInfo.zoomInstructionsBulletThree',
    defaultMessage: 'Double click to return to the original zoom level',
  },
  insightsHeading: {
    id: 'JobDetailsInfo.insightsHeading',
    defaultMessage: 'Insights',
  },
  insightsInstructionsBulletOne: {
    id: 'JobDetailsInfo.insightsInstructionsBulletOne',
    defaultMessage: 'Verify that all tubes were cleaned',
  },
  insightsInstructionsBulletTwo: {
    id: 'JobDetailsInfo.insightsInstructionsBulletTwo',
    defaultMessage: 'Identify tubes that may still be clogged and see how deep that blockage is',
  },
  insightsInstructionsBulletThree: {
    id: 'JobDetailsInfo.insightsInstructionsBulletThree',
    defaultMessage: 'Identify tubes that were unblocked',
  },
  insightsAdditionalInformation: {
    id: 'JobDetailsInfo.insightsAdditionalInformation',
    defaultMessage:
      "Additionally, if you ran at the wrong pressure or with the wrong nozzles for a part of the job, you may adjust the time range display for the corrected duration. (In this scenario, note the tubes that were 'cleaned'. These may need to be re-cleaned.)",
  },
  tubeSheetTimeInTube: {
    id: 'JobDetailsInfo.tubeSheetTimeInTube',
    defaultMessage: 'Time in tube',
  },
  tubeSheetLanceSpeed: {
    id: 'JobDetailsInfo.tubeSheetLanceSpeed',
    defaultMessage: 'Lance speed',
  },
  tubeSheetDepth: {
    id: 'JobDetailsInfo.tubeSheetDepth',
    defaultMessage: 'Depth of Tube',
  },
  depthCleanedDescription: {
    id: 'JobDetailsInfo.depthCleanedDescription',
    defaultMessage: 'The approximate distance the lance traveled through the tube in preferred units (feet or meters)',
  },
  autoStrokeWithTimeTitle: {
    id: 'JobDetailsInfo.autoStrokeWithTimeTitle',
    defaultMessage: 'AutoStroke (Time)',
  },
  autostrokeInfo: {
    id: 'JobDetailsInfo.autostrokeInfo',
    defaultMessage: 'The depth and time when AutoStroke was engaged',
  },
  issuesHeading: {
    id: 'JobDetailsInfo.issuesHeading',
    defaultMessage: 'Issues',
  },
  issuesInfo: {
    id: 'JobDetailsInfo.issuesInfo',
    defaultMessage:
      'The tube sheet looks incorrect, there is a shift or misaligned points. This issue is caused by an unexpected shift in the origin of the tube coordinate system.',
  },
  issuesInfoBulletOne: {
    id: 'JobDetailsInfo.issuesInfoBulletOne',
    defaultMessage: 'The power hub was turned off/lost power mid job',
  },
  issuesInfoBulletTwo: {
    id: 'JobDetailsInfo.issuesInfoBulletTwo',
    defaultMessage: 'The tractor was manually moved mid job',
  },
  issuesInfoBulletThree: {
    id: 'JobDetailsInfo.issuesInfoBulletThree',
    defaultMessage: 'Multiple exchangers ran as the same job',
  },
  graphingIssuesHeading: {
    id: 'JobDetailsInfo.graphingIssuesHeading',
    defaultMessage: 'Graphing Issues',
  },
  graphingIssuesSubHeading: {
    id: 'JobDetailsInfo.graphingIssuesSubHeading',
    defaultMessage:
      'If the tube sheet looks incorrect, this issue is typically caused by an unexpected shift in the origin of the tube coordinate system.  For example:',
  },
  graphingIssuesSuggestion: {
    id: 'JobDetailsInfo.graphingIssuesSuggestion',
    defaultMessage:
      "Try to avoid disrupting or moving equipment during a job.  If you need to move the robot manually, it is best to start another 'Job' via the controller and have two cleaning logs.",
  },
  correctTubeSheetLabel: {
    id: 'JobDetailsInfo.correctTubeSheetLabel',
    defaultMessage: 'Correct Tube Sheet',
  },
  shiftedOriginTubeSheetLabel: {
    id: 'JobDetailsInfo.shiftedOriginTubeSheetLabel',
    defaultMessage: 'Shifted Origin',
  },
  elapsedTime: {
    id: 'JobDetailsInfo.elapsedTime',
    defaultMessage: 'Elapsed Time',
  },
  jobDetails: {
    id: 'JobDetailsInfo.jobDetailsHeading',
    defaultMessage: 'Job Details',
  },
  jobInfoSubHeading: {
    id: 'JobDetailsInfo.jobInfoSubHeading',
    defaultMessage: 'Created by {userName} on {date}',
  },
  jobComplete: {
    id: 'JobDetailsInfo.jobComplete',
    defaultMessage: 'Complete',
  },
  jobLive: {
    id: 'JobDetailsInfo.jobLive',
    defaultMessage: 'Live',
  },
  jobInProgress: {
    id: 'JobDetailsInfo.jobInProgress',
    defaultMessage: 'In Progress',
  },
  jobInfoPrintDialogHeader: {
    id: 'JobInfoPrint.header',
    defaultMessage: 'Print Job Log',
  },
  jobInfoPrintDialogSubHeader: {
    id: 'JobInfoPrint.subHeader',
    defaultMessage: "Select information you'd like to print",
  },
  jobInfoPrintDialogOptionsHeader: {
    id: 'JobInfoPrint.optionsHeader',
    defaultMessage: 'Charts & Graphs',
  },
  jobInfoPrintDialogOptionTubes: {
    id: 'JobInfoPrint.optionTubes',
    defaultMessage: 'Tubes',
  },
  jobInfoPrintDialogOptionTubesCleaned: {
    id: 'JobInfoPrint.jobInfoPrintDialogOptionTubesCleaned',
    defaultMessage: 'Tubes Cleaned',
  },
  jobInfoPrintDialogOptionTubesCompletion: {
    id: 'JobInfoPrint.jobInfoPrintDialogOptionTubesCompletion',
    defaultMessage: 'Tube Sheet - Completion',
  },
  jobInfoPrintDialogOptionTubesTime: {
    id: 'JobInfoPrint.jobInfoPrintDialogOptionTubesTime',
    defaultMessage: 'Tube Sheet - Time in Tube',
  },
  jobInfoPrintDialogOptionTubesDepthCleaned: {
    id: 'JobInfoPrint.jobInfoPrintDialogOptionTubesDepthCleaned',
    defaultMessage: 'Tube Sheet - Depth Cleaned',
  },
  jobInfoPrintDialogOptionTubesAutostrokes: {
    id: 'JobInfoPrint.jobInfoPrintDialogOptionTubesAutostrokes',
    defaultMessage: 'Tube Sheet - Autostrokes',
  },
  jobInfoPrintDialogOptionTubesLanceSpeed: {
    id: 'JobInfoPrint.jobInfoPrintDialogOptionTubesLanceSpeed',
    defaultMessage: 'Tube Sheet - Lance Speed',
  },
  jobInfoPrintDialogOptionAnnotations: {
    id: 'JobInfoPrint.optionAnnotations',
    defaultMessage: 'Annotations and Comments',
  },
  jobInfoPrintDialogOptionTimestamps: {
    id: 'JobInfoPrint.optionTimestamps',
    defaultMessage: 'Include timestamps',
  },
  jobInfoPrintDialogOptionPressure: {
    id: 'JobInfoPrint.optionPressure',
    defaultMessage: 'Pressure',
  },
  jobInfoPrintDialogOptionPieCharts: {
    id: 'JobInfoPrint.optionPieCharts',
    defaultMessage: 'Pie Charts',
  },
  jobInfoPrintDialogOptionIdle: {
    id: 'JobInfoPrint.optionIdle',
    defaultMessage: 'Idle vs Pressure',
  },
  jobInfoPrintDialogOptionConfig: {
    id: 'JobInfoPrint.optionConfig',
    defaultMessage: 'Configurations',
  },
  jobInfoSummaryTubesCleaned: {
    id: 'JobInfoSummary.tubesCleaned',
    defaultMessage: 'Tubes Cleaned',
  },
  jobInfoSummaryTimeInTube: {
    id: 'JobInfoSummary.timeInTube',
    defaultMessage: 'Avg. time in tube',
  },
  jobInfoSummaryActiveRunTime: {
    id: 'JobInfoSummary.activeRunTime',
    defaultMessage: 'Active run time',
  },
  jobInfoSummaryController: {
    id: 'JobInfoSummary.controller',
    defaultMessage: 'Controller',
  },
  jobInfoEstimatedTimeToCompletionLabel: {
    id: 'JobInfoSummary.jobInfoEstimatedTimeToCompletionLabel',
    defaultMessage: 'Est. Completion Time',
    description: 'Label for estimated time to completion value.',
  },
  jobInfoSummarySiteName: {
    id: 'JobInfoSummary.siteName',
    defaultMessage: 'Site Name',
  },
  jobInfoSummaryModelNumber: {
    id: 'JobInfoSummary.modelNumber',
    defaultMessage: 'HX Model Number',
  },
  jobInfoSummaryDescription: {
    id: 'JobInfoSummary.description',
    defaultMessage: 'Description',
  },
  jobInfoSharedWithLabel: {
    id: 'JobInfoSummary.sharedWithLabel',
    defaultMessage: 'Report Shared With',
  },
  jobInfoSharedWithNone: {
    id: 'JobInfoSummary.sharedWithNone',
    defaultMessage: 'None',
  },
  jobInfoSummaryLastUpdatedLabel: {
    id: 'JobInfoSummary.lastUpdatedLabel',
    defaultMessage: 'Last Updated',
  },
  jobInfoSummaryLanceSpeedLabel: {
    id: 'JobInfoSummary.lanceSpeedLabel',
    defaultMessage: 'Average Lance Speed',
  },
  jobInfoSummaryViewMore: {
    id: 'JobInfoSummary.viewMore',
    defaultMessage: 'View more...',
  },
  jobInfoSummaryViewLess: {
    id: 'JobInfoSummary.viewLess',
    defaultMessage: 'View less...',
  },
  jobInfoNotProvided: {
    id: 'JobInfoSummary.jobInfoNotProvided',
    defaultMessage: 'Not Provided',
  },
  jobCardLinesParsed: {
    id: 'JobCard.linesParsed',
    defaultMessage: '{linesParsed} lines parsed',
    description: 'Shows the number of log lines parsed, where linesParsed is a number variable.',
  },
  startTime: {
    id: 'RecentJobCard.startTime',
    defaultMessage: 'Start Time',
  },
  endTime: {
    id: 'RecentJobCard.endTime',
    defaultMessage: 'End Time',
  },
  activeRunTime: {
    id: 'RecentJobCard.activeRunTime',
    defaultMessage: 'Active Run Time',
  },
  tubes: {
    id: 'RecentJobCard.tubes',
    defaultMessage: 'Tubes',
  },
  tubesPerHour: {
    id: 'RecentJobCard.tubesPerHour',
    defaultMessage: 'Tubes Per Hour',
  },
  controllerOff: {
    id: 'RecentJobCard.controllerOff',
    defaultMessage: 'Controller Off',
  },
  idle: {
    id: 'RecentJobCard.idle',
    defaultMessage: 'Idle',
  },
  other: {
    id: 'RecentJobCard.other',
    defaultMessage: 'OtherJob',
  },
  noSystemStateData: {
    id: 'RecentJobCard.noSystemStateData',
    defaultMessage: 'No System State Time Data',
  },
  automaticConfigHeading: {
    id: 'Configuration.automaticConfigHeading',
    defaultMessage: 'Automatic Configuration',
  },
  automaticConfigOverviewDescription: {
    id: 'Configuration.automaticConfigOverviewDescription',
    defaultMessage: 'The automation configuration section captures your Job setup data',
  },
  automaticConfigInsightDescription: {
    id: 'Configuration.automaticConfigInsightDescription',
    defaultMessage:
      'You may view the configuration which worked for this exchanger should you need to clean it, or a similar one, again.',
  },
  systemConfigHeading: {
    id: 'Configuration.systemConfigHeading',
    defaultMessage: 'System Configuration',
  },
  systemConfigOverviewDescription: {
    id: 'Configuration.systemConfigOverviewDescription',
    defaultMessage: 'The system configuration section captures your Job setup data',
  },
  systemConfigInsightDescription: {
    id: 'Configuration.systemConfigInsightDescription',
    defaultMessage:
      'You may view the configuration which worked for this exchanger should you need to clean it, or a similar one, again.',
  },
  tractorConfigHeading: {
    id: 'Configuration.tractorConfigHeading',
    defaultMessage: 'Tractor Configuration',
  },
  tractorConfigOverviewDescription: {
    id: 'Configuration.tractorConfigOverviewDescription',
    defaultMessage: 'The tractor configuration section captures your Job setup data.',
  },
  tractorConfigInsightDescription: {
    id: 'Configuration.tractorConfigInsightDescription',
    defaultMessage:
      'You may view the configuration which worked for this exchanger should you need to clean it, or a similar one, again.',
  },
  clampPressureHeading: {
    id: 'Pressure.clampPressureHeading',
    defaultMessage: 'Clamp Pressure',
  },
  clampPressureOverviewDescriptionOne: {
    id: 'Pressure.clampPressureOverviewDescriptionOne',
    defaultMessage:
      'The clamp pressure refers the pressure (or force over area of contact) applied into the lances by the driving belt.',
  },
  clampPressureOverviewDescriptionTwo: {
    id: 'Pressure.clampPressureOverviewDescriptionTwo',
    defaultMessage:
      'The recommended clamp pressure is in the range of 10.0-30.0 psi This is represented in the graph via the green band.',
  },
  clampPressureInsightDescriptionOne: {
    id: 'Pressure.clampPressureInsightDescriptionOne',
    defaultMessage: 'Clamp Pressure is running ABOVE the recommended range.',
  },
  clampPressureInsightDescriptionOneBullet: {
    id: 'Pressure.clampPressureInsightDescriptionOneBullet',
    defaultMessage:
      'Running above the recommended clamp pressure can cause additional wear on the lances, and will shorten their expected lifetime.',
  },
  clampPressureInsightDescriptionTwo: {
    id: 'Pressure.clampPressureInsightDescriptionTwo',
    defaultMessage: 'Clamp pressure is running BELOW the recommended range.',
  },
  clampPressureInsightDescriptionTwoBullet: {
    id: 'Pressure.clampPressureInsightDescriptionTwoBullet',
    defaultMessage:
      'Running below the recommended clamp pressure can cause lances to stall out, even when there is no blockage in a tube. It can also result in additional (and maybe unnecessary) autostroke events, which increases clean times.',
  },
  clampPressureInsightDescriptionThree: {
    id: 'Pressure.clampPressureInsightDescriptionThree',
    defaultMessage: 'Clamp pressure spiking:',
  },
  clampPressureInsightDescriptionThreeBullet: {
    id: 'Pressure.clampPressureInsightDescriptionThreeBullet',
    defaultMessage:
      'This pattern is likely caused by a leak in the clamp pressure hose. Inspect the hose for any leaks and ensure that the hose is properly inserted into the fitting.',
  },
  inletPressureHeading: {
    id: 'Pressure.inletPressureHeading',
    defaultMessage: 'Inlet Pressure',
  },
  inletPressureOverviewDescription: {
    id: 'Pressure.inletPressureOverviewDescription',
    defaultMessage:
      'Inlet pressure is the air pressure supplied to the system at the power hub. This drives all motion of your Sentinel enabled device, including positioning motors and the lance feeding tractor. Typical Inlet Pressure: 100.0 psi',
  },
  inletPressureInsightDescriptionOne: {
    id: 'Pressure.inletPressureInsightDescriptionOne',
    defaultMessage: 'Gaps in the graph represent when the controller or the power hub was off.',
  },
  inletPressureInsightDescriptionTwo: {
    id: 'Pressure.inletPressureInsightDescriptionTwo',
    defaultMessage:
      'Running with inlet pressure ABOVE the recommended pressure can risk damaging the system and motors.',
  },
  inletPressureInsightDescriptionThree: {
    id: 'Pressure.inletPressureInsightDescriptionThree',
    defaultMessage:
      'Running with inlet pressure BELOW the recommended pressure can result in poorer performance and longer cleaning times',
  },
  waterPressureHeading: {
    id: 'Pressure.waterPressureHeading',
    defaultMessage: 'Water Pressure',
  },
  waterPressureOverviewDescription: {
    id: 'Pressure.waterPressureOverviewDescription',
    defaultMessage: 'This graph displays the readings from the high pressure water transducer.',
  },
  waterPressureInsightDescriptionOne: {
    id: 'Pressure.waterPressureInsightDescriptionOne',
    defaultMessage: 'You can ensure you were running at the correct pressure for your job.',
  },
  waterPressureInsightDescriptionOneBullet: {
    id: 'Pressure.waterPressureInsightDescriptionOneBullet',
    defaultMessage:
      'If the pressure was wrong for a portion of the job, you can set the time range to show which tubes need to be re-cleaned.',
  },
  waterPressureInsightDescriptionTwo: {
    id: 'Pressure.waterPressureInsightDescriptionTwo',
    defaultMessage: 'You can see if your nozzles are beginning to fail if the pressure is dropping.',
  },
  waterPressureIssuesDescription: {
    id: 'Pressure.waterPressureIssuesDescription',
    defaultMessage: 'This graph will only display if you correctly use the high pressure water transducer (HPWT).',
  },
  systemUsageHeading: {
    id: 'PieCharts.systemUsageHeading',
    defaultMessage: 'System Usage',
  },
  systemUsageOverviewDescription: {
    id: 'PieCharts.systemUsageOverviewDescription',
    defaultMessage: 'This pie chart shows actuation the system was doing over the course of a job',
  },
  systemUsageLegendPositioning: {
    id: 'PieCharts.systemUsageLegendPositioning',
    defaultMessage: 'Positioning - When the tractor is actively moving on the rails',
  },
  systemUsageLegendLanceFeeding: {
    id: 'PieCharts.systemUsageLanceFeeding',
    defaultMessage: 'Lance Feeding - The time the lances are actively being fed in and out',
  },
  systemUsageOverviewLegendControllerOff: {
    id: 'PieCharts.systemUsageLegendControllerOff',
    defaultMessage: 'Controller Off - The time that the controller was off and not logging data.',
  },
  systemUsageOverviewLegendIdle: {
    id: 'PieCharts.systemUsageLegendIdle',
    defaultMessage: 'Idle - any time the controller was on, but not positioning or feeding.',
  },
  systemUsageInsightDescriptionOne: {
    id: 'PieCharts.systemUsageInsightDescriptionOne',
    defaultMessage: 'Long controller off times',
  },
  systemUsageInsightDescriptionOneBullet: {
    id: 'PieCharts.systemUsageInsightDescriptionOneBullet',
    defaultMessage:
      "Long controller off times can be a result of running the same 'job' over the course of multiple days or exchangers. Always be sure to start a new job for each exchanger and upload job logs in a timely manner",
  },
  systemUsageInsightDescriptionTwo: {
    id: 'PieCharts.systemUsageInsightDescriptionTwo',
    defaultMessage: 'Long idle times',
  },
  systemUsageInsightDescriptionTwoBullet: {
    id: 'PieCharts.systemUsageInsightDescriptionTwoBullet',
    defaultMessage:
      'This category can mean a number of things happened during the job, including setup, breakdown, nozzle switches, tractor re-positioning, and other troubleshooting. Consider taking notes of when these activities happen to get a better breakdown of idle time usage.',
  },
  highPressureHeading: {
    id: 'PieCharts.highPressureHeading',
    defaultMessage: 'High Pressure',
  },
  systemHeading: {
    id: 'PieCharts.systemHeading',
    defaultMessage: 'System',
  },
  highPressureOverviewDescription: {
    id: 'PieCharts.highPressureOverviewDescription',
    defaultMessage: 'This pie chart shows the the time at pressure vs not at pressure.',
  },
  highPressureOverviewLegendOn: {
    id: 'PieCharts.highPressureOverviewLegendOn',
    defaultMessage: 'High Pressure On - Time that the system was using high pressure water (idle, moving, or lancing)',
  },
  highPressureOverviewLegendOff: {
    id: 'PieCharts.highPressureOverviewLegendOff',
    defaultMessage: 'High Pressure Off - Time that the system was on, but high pressure water was not running',
  },
  highPressureOverviewLegendControllerOff: {
    id: 'PieCharts.highPressureOverviewLegendControllerOff',
    defaultMessage: 'Controller Off - The time that the controller was off and not logging data.',
  },
  heatMapInformation: {
    id: 'HeatMap.heatMapInformation',
    defaultMessage:
      'The time in tube heat map displays a range of the duration of time the lance was in the tube while cleaning. This information can be helpful in identifying tubes that have taken longer to clean over time. This may provide insight to any potential issues that can be addressed if the same tubes are always taking longer to clean than the others',
  },
  heatMapHeading: {
    id: 'HeatMap.heatMapHeading',
    defaultMessage: 'Time in Tube Heat Map',
  },
  vennDiagramHeading: {
    id: 'VennDiagram.vennDiagramHeading',
    defaultMessage: 'Idle Vs High Pressure',
  },
  vennDiagramOverviewDescription: {
    id: 'VennDiagram.vennDiagramOverviewDescription',
    defaultMessage: 'This chart shows the overlap of idle/off and high pressure time.',
  },
  vennDiagramLegendHighPressure: {
    id: 'VennDiagram.vennDiagramLegendHighPressure',
    defaultMessage: 'High Pressure - Time that the system was using high pressure water (idle, moving, or lancing)',
  },
  vennDiagramLegendHighIdleOff: {
    id: 'VennDiagram.vennDiagramLegendIdleOff',
    defaultMessage: 'Idle/Off - Time that the system was either off, or on and not being operated',
  },
  vennDiagramLegendOverlap: {
    id: 'VennDiagram.vennDiagramLegendOverlap',
    defaultMessage: 'Overlap - The time the system was running high pressure water, but not being used',
  },
  vennDiagramInsightDescription: {
    id: 'VennDiagram.vennDiagramInsightsDescription',
    defaultMessage: 'The overlap of idle time with high pressure water indicates an opportunity to optimize operation:',
  },
  vennDiagramInsightDescriptionBullet: {
    id: 'VennDiagram.vennDiagramInsightsDescriptionBullet',
    defaultMessage:
      'When the system is idle, it is not positioning or feeding, so high pressure water used during this time is not used for cleaning. As a result, the pump may be engaged and burning fuel/expelling water while not cleaning, resulting in wasted resources. Reducing this overlap can help save fuel and water costs.',
  },
  jobTimeRangeTitle: {
    id: 'JobTimeRange.title',
    defaultMessage: 'Time Range',
  },
  jobTimeOptionCalendar: {
    id: 'JobTimeOption.calendar',
    defaultMessage: 'Calendar Time',
  },
  jobTimeOptionRun: {
    id: 'JobTimeOption.run',
    defaultMessage: 'Runtime',
  },
  jobScaleOptionLinear: {
    id: 'JobScaleOption.linear',
    defaultMessage: 'Linear Scale',
  },
  jobScaleOptionLog: {
    id: 'JobScaleOption.log',
    defaultMessage: 'Log Scale',
  },
  commentHasBeenDeleted: {
    id: 'JobInfo.commentHasBeenDeleted',
    defaultMessage: 'This comment has been deleted',
  },
  undo: {
    id: 'JobInfo.undo',
    defaultMessage: 'Undo',
  },
  deleteLogTitle: {
    id: 'JobInfo.deleteLogTitle',
    defaultMessage: 'Delete log file?',
    description: 'Title for the delete log file warning modal',
  },
  deleteLogFileButtonText: {
    id: 'JobInfo.deleteLogFileButtonText',
    defaultMessage: 'Delete Log File',
    description: 'Label for the delete log file button.',
  },
  shareLog: {
    id: 'JobInfo.shareLog',
    defaultMessage: 'Share Log',
  },
  unshareLog: {
    id: 'JobInfo.unshareLog',
    defaultMessage: 'Unshare Log',
  },
  deleteLog: {
    id: 'JobInfo.deleteLog',
    defaultMessage: 'Delete Log',
  },
  downloadLog: {
    id: 'JobInfo.downloadLog',
    defaultMessage: 'Download Log',
  },
  mayShareWithAllOrgMembersMessage: {
    id: 'JobInfo.mayShareWithAllOrgMembersMessage',
    defaultMessage:
      'If this user is within a Sentinel Link organization, all organization members will be able to view this job.',
  },
  annotations: {
    id: 'JobInfo.annotations',
    defaultMessage: 'Annotations and Comments',
  },
  timeStamps: {
    id: 'JobInfo.timeStamps',
    defaultMessage: 'Include timestamps',
  },
  configuration: {
    id: 'JobInfo.configuration',
    defaultMessage: 'Configuration',
  },
  pressure: {
    id: 'JobInfo.pressure',
    defaultMessage: 'Pressure',
  },
  pieCharts: {
    id: 'JobInfo.pieCharts',
    defaultMessage: 'Pie Charts',
  },
  idleVsPressure: {
    id: 'JobInfo.idleVsPressure',
    defaultMessage: 'Idle vs Pressure',
  },
  chartsAndGraphs: {
    id: 'JobInfo.chartsAndGraphs',
    defaultMessage: 'Charts & Graphs',
  },
  additionalSettings: {
    id: 'JobInfo.additionalSettings',
    defaultMessage: 'Additional Settings',
  },
  selectInformationToShare: {
    id: 'JobInfo.selectInformationToShare',
    defaultMessage: "Select information you'd like to share",
  },
  shareReport: {
    id: 'JobInfo.shareReport',
    defaultMessage: 'Share Report',
  },
  shareExpirationShortLabel: {
    id: 'JobInfo.shareExpirationShortLabel',
    defaultMessage: '15 days',
  },
  shareExpirationMediumLabel: {
    id: 'JobInfo.shareExpirationMediumLabel',
    defaultMessage: '30 days',
  },
  shareExpirationLongLabel: {
    id: 'JobInfo.shareExpirationLongLabel',
    defaultMessage: '45 days',
  },
  selectAnOrganization: {
    id: 'JobInfo.selectAnOrganization',
    defaultMessage: 'Select an organization',
  },
  selectAController: {
    id: 'JobInfo.selectAController',
    defaultMessage: 'Select a controller',
  },
  selectAnInternalOrganization: {
    id: 'JobInfo.selectAnInternalOrganization',
    defaultMessage: 'Select an internal organization',
  },
  selectAnAssetOwnerOrg: {
    id: 'JobShareForm.selectAnAssetOwnerOrg',
    defaultMessage: 'Select an asset owner organization',
  },
  assetOwnerLabel: {
    id: 'JobShareForm.assetOwnerLabel',
    defaultMessage: 'Asset Owner',
  },
  addOrgTitle: {
    id: 'JobShareForm.addOrgTitle',
    defaultMessage: 'Add Family Org',
  },
  addOrgSubtitle: {
    id: 'JobShareForm.addOrgSubtitle',
    defaultMessage: 'Internal',
  },
  addGuestTitle: {
    id: 'JobShareForm.addGuestTitle',
    defaultMessage: 'Add Guest',
  },
  addGuestSubtitle: {
    id: 'JobShareForm.addGuestSubtitle',
    defaultMessage: 'External',
  },
  shareRecipientDetailsLabel: {
    id: 'jobShareForm.shareRecipientDetailsLabel',
    defaultMessage: 'Recipient Details',
  },
  shareExpirationLabel: {
    id: 'jobShareForm.shareExpirationLabel',
    defaultMessage: 'Share Expiration',
  },
  manageSharingTitle: {
    id: 'JobInfo.manageSharingTitle',
    defaultMessage: 'Manage Sharing',
  },
  shareJobSuccessMessage: {
    id: 'JobInfo.shareJobSuccessMessage',
    defaultMessage: 'Success! This job has successfully been shared with {orgName}.',
  },
  unshareJobSuccessMessage: {
    id: 'JobInfo.unshareJobSuccessMessage',
    defaultMessage: 'Success! This job is no longer shared with {orgNames}.',
  },
  shareFailureMessage: {
    id: 'JobInfo.shareFailureMessage',
    defaultMessage: 'Error! This job was not shared successfully.',
  },
  unshareFailureMessage: {
    id: 'JobInfo.unshareFailureMessage',
    defaultMessage: 'Error! Failed to un-share the job. Please try again.',
  },
  unshareJobConfirmationTitle: {
    id: 'JobInfo.unshareJobConfirmationTitle',
    defaultMessage: 'Unshare Job',
  },
  unshareJobDescription: {
    id: 'JobInfo.unshareJobDescription',
    defaultMessage: 'Who Has Access',
  },
  unshareJobConfirmationDescription: {
    id: 'JobInfo.unshareJobConfirmationDescription',
    defaultMessage:
      "Are you sure you'd like to unshare this job?  The organization will no longer be able to view this job log.",
  },
  unshareJobConfirmationButtonText: {
    id: 'JobInfo.unshareJobConfirmationButtonText',
    defaultMessage: 'Remove Selected',
  },
  unshareJobSelectForUnsharing: {
    id: 'JobInfo.unshareJobSelectForUnsharing',
    defaultMessage: 'Remove Access',
  },
  unshareJobDeselectForUnsharing: {
    id: 'JobInfo.unshareJobDeselectForUnsharing',
    defaultMessage: 'Undo',
  },
  successfulJobDeletionMessage: {
    id: 'JobInfo.successfulJobDeletionMessage',
    defaultMessage: 'Success! Job file has been deleted.',
  },
  infoOverviewHeader: {
    id: 'JobConfig.infoOverviewHeader',
    defaultMessage: 'Overview',
  },
  infoInsightsHeader: {
    id: 'JobConfig.infoInsightsHeader',
    defaultMessage: 'Insights',
  },
  tractorInfoOverview: {
    id: 'JobConfig.tractorInfoOverview',
    defaultMessage: 'The tractor configuration section captures your Job setup data.',
  },
  tractorInfoInsights: {
    id: 'JobConfig.tractorInfoInsights',
    defaultMessage:
      'You may view the configuration which worked for this exchanger should you need to clean it, or a similar one, again.',
  },
  systemInfoOverview: {
    id: 'JobConfig.systemInfoOverview',
    defaultMessage: 'The system configuration section captures your Job setup data.',
  },
  systemInfoInsights: {
    id: 'JobConfig.systemInfoInsights',
    defaultMessage:
      'You may view the configuration which worked for this exchanger should you need to clean it, or a similar one, again.',
  },
  autoInfoOverview: {
    id: 'JobConfig.autoInfoOverview',
    defaultMessage: 'The automation configuration section captures your Job setup data.',
  },
  autoInfoInsights: {
    id: 'JobConfig.autoInfoInsights',
    defaultMessage:
      'You may view the configuration which worked for this exchanger should you need to clean it, or a similar one, again.',
  },
  tractorInfoHeader: {
    id: 'JobConfig.tractorInfoHeader',
    defaultMessage: 'Tractor Configuration',
  },
  tractorInfoClamp: {
    id: 'JobConfig.tractorInfoClamp',
    defaultMessage: 'Clamp Status',
  },
  tractorInfoClampNone: {
    id: 'JobConfig.tractorInfoClampNone',
    defaultMessage: 'No Clamp Status Available',
  },
  tractorInfoClampLabel: {
    id: 'JobConfig.tractorInfoClampLabel',
    defaultMessage: 'Clamp',
  },
  tractorInfoLance: {
    id: 'JobConfig.tractorInfoLance',
    defaultMessage: 'Lance Status',
  },
  tractorInfoLanceNone: {
    id: 'JobConfig.tractorInfoLanceNone',
    defaultMessage: 'No Lance Status Available',
  },
  tractorInfoLanceLabel: {
    id: 'JobConfig.tractorInfoLanceLabel',
    defaultMessage: 'Lance',
  },
  tractorInfoLanceActive: {
    id: 'JobConfig.tractorInfoLanceActive',
    defaultMessage: '{value} Active Lances',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  tractorInfoLanceStatus: {
    id: 'JobConfig.tractorInfoLanceStatus',
    defaultMessage: '(lance1Enabled={lance1}, lance1Enabled={lance2}, lance1Enabled={lance3})',
  },
  tractorInfoBelt: {
    id: 'JobConfig.tractorInfoBelt',
    defaultMessage: 'Belt Status',
  },
  tractorInfoBeltNone: {
    id: 'JobConfig.tractorInfoBeltNone',
    defaultMessage: 'No Belt Status Available',
  },
  tractorInfoBeltLabel: {
    id: 'JobConfig.tractorInfoBeltLabel',
    defaultMessage: 'Belt',
  },
  tractorInfoStop: {
    id: 'JobConfig.tractorInfoStop',
    defaultMessage: 'Stop Sensor Status',
  },
  tractorInfoStopNone: {
    id: 'JobConfig.tractorInfoStopNone',
    defaultMessage: 'No Stop Sensor Status Available',
  },
  tractorInfoStopLabel: {
    id: 'JobConfig.tractorInfoStopLabel',
    defaultMessage: 'Stop sensor',
  },
  tractorInfoStopSwap: {
    id: 'JobConfig.tractorInfoStopSwap',
    defaultMessage: '(isSwapped={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  tractorInfoStopSwapTrue: {
    id: 'JobConfig.tractorInfoStopSwapTrue',
    defaultMessage: 'Stop sensors have been swapped',
  },
  tractorInfoStopSwapFalse: {
    id: 'JobConfig.tractorInfoStopSwapFalse',
    defaultMessage: 'Stop sensors are in normal orientation',
  },
  tractorInfoStopThresholdLabel: {
    id: 'JobConfig.tractorInfoStopThresholdLabel',
    defaultMessage: 'Threshold value = {value}',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  tractorInfoStopThreshold: {
    id: 'JobConfig.tractorInfoStopThreshold',
    defaultMessage: '(threshold={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  systemInfoInlet: {
    id: 'JobConfig.systemInfoInlet',
    defaultMessage: 'Inlet Config(s)',
  },
  systemInfoHeader: {
    id: 'JobConfig.systemInfoHeader',
    defaultMessage: 'System Configuration',
  },
  systemInfoInletNone: {
    id: 'JobConfig.systemInfoInletNone',
    defaultMessage: 'No Inlet Status Available',
  },
  systemInfoPositioner: {
    id: 'JobConfig.systemInfoPositioner',
    defaultMessage: 'Positioner Status',
  },
  systemInfoPositionerNone: {
    id: 'JobConfig.systemInfoPositionerNone',
    defaultMessage: 'No Positioner Status Available',
  },
  systemInfoDump: {
    id: 'JobConfig.systemInfoDump',
    defaultMessage: 'Dump Status',
  },
  systemInfoDumpNone: {
    id: 'JobConfig.systemInfoDumpNone',
    defaultMessage: 'No Dump Status Available',
  },
  systemInfoDumpLabel: {
    id: 'JobConfig.systemInfoDumpLabel',
    defaultMessage: 'Dump',
  },
  systemInfoDumpType: {
    id: 'JobConfig.systemInfoDumpType',
    defaultMessage: '(dumpType={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  systemInfoDumpTypeOne: {
    id: 'JobConfig.systemInfoDumpTypeOne',
    defaultMessage: 'Not using a dump',
  },
  systemInfoDumpTypeTwo: {
    id: 'JobConfig.systemInfoDumpTypeTwo',
    defaultMessage: 'Using a pneumatic dump',
  },
  systemInfoDumpTypeThree: {
    id: 'JobConfig.systemInfoDumpTypeThree',
    defaultMessage: 'Using an electronic dump',
  },
  systemInfoInletLabel: {
    id: 'JobConfig.systemInfoInletLabel',
    defaultMessage: 'Inlet',
  },
  systemInfoPositionerPlumb: {
    id: 'JobConfig.systemInfoPositionerPlumb',
    defaultMessage: 'Carriage plumbing',
  },
  systemInfoPositionerCali: {
    id: 'JobConfig.systemInfoPositionerCali',
    defaultMessage: 'Carriage calibration',
  },
  systemInfoPositionerMountInvertX: {
    id: 'JobConfig.systemInfoPositionerMountInvertX',
    defaultMessage: 'Carriage X axis has inverted orientation',
  },
  systemInfoPositionerMountNormalX: {
    id: 'JobConfig.systemInfoPositionerMountNormalX',
    defaultMessage: 'Carriage X axis has normal orientation',
  },
  systemInfoPositionerMountInvertY: {
    id: 'JobConfig.systemInfoPositionerMountInvertY',
    defaultMessage: 'Carriage Y axis has inverted orientation',
  },
  systemInfoPositionerMountNormalY: {
    id: 'JobConfig.systemInfoPositionerMountNormalY',
    defaultMessage: 'Carriage Y axis has normal orientation',
  },
  systemInfoPositionerMountLabelX: {
    id: 'JobConfig.systemInfoPositionerMountLabelX',
    defaultMessage: '(isInvertedX={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  systemInfoPositionerMountLabelY: {
    id: 'JobConfig.systemInfoPositionerMountLabelY',
    defaultMessage: '(isInvertedY={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoHeader: {
    id: 'JobConfig.autoInfoHeader',
    defaultMessage: 'Automation Configuration',
  },
  autoInfoAutoMove: {
    id: 'JobConfig.autoInfoAutoMove',
    defaultMessage: 'Auto Move Status',
  },
  autoInfoAutoMoveNone: {
    id: 'JobConfig.autoInfoAutoMoveNone',
    defaultMessage: 'No Auto Move Status Available',
  },
  autoInfoAutoFeed: {
    id: 'JobConfig.autoInfoFeedStatus',
    defaultMessage: 'Auto Feed Status',
  },
  autoInfoAutoFeedNone: {
    id: 'JobConfig.autoInfoAutoFeedNone',
    defaultMessage: 'No Auto Feed Status Available',
  },
  autoInfoAutoFeedLabel: {
    id: 'JobConfig.autoInfoAutoFeedLabel',
    defaultMessage: 'Auto Feed',
  },
  autoInfoAutoStroke: {
    id: 'JobConfig.autoInfoAutoStroke',
    defaultMessage: 'Autostroke Status',
  },
  autoInfoAutoStrokeNone: {
    id: 'JobConfig.autoInfoAutoStrokeNone',
    defaultMessage: 'No Autostroke Status Available',
  },
  autoInfoAutoStrokeLabel: {
    id: 'JobConfig.autoInfoAutoStrokeLabel',
    defaultMessage: 'Autostroke',
  },
  autoInfoAutoStrokeBack: {
    id: 'JobConfig.autoInfoAutoStrokeBack',
    defaultMessage: 'Backout Duration: {value} ms',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoStrokeBackLabel: {
    id: 'JobConfig.autoInfoAutoStrokeBackLabel',
    defaultMessage: '(backoutDuration={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoStrokePulse: {
    id: 'JobConfig.autoInfoAutoStrokePulse',
    defaultMessage: 'Pulse Duration: {value} ms',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoStrokePulseLabel: {
    id: 'JobConfig.autoInfoAutoStrokePulseLabel',
    defaultMessage: '(pulseDuration={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoStrokePause: {
    id: 'JobConfig.autoInfoAutoStrokePause',
    defaultMessage: 'Pause Duration: {value} ms',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoStrokePauseLabel: {
    id: 'JobConfig.autoInfoAutoStrokePauseLabel',
    defaultMessage: '(pauseDuration={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoMoveLabel: {
    id: 'JobConfig.autoInfoAutoMoveLabel',
    defaultMessage: 'Auto Move',
  },
  autoInfoAutoMovePitch: {
    id: 'JobConfig.autoInfoAutoMovePitch',
    defaultMessage: 'Pitch= {value}',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoMovePitchLabel: {
    id: 'JobConfig.autoInfoAutoMovePitchLabel',
    defaultMessage: '(pitch={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoMovePattern: {
    id: 'JobConfig.autoInfoAutoMovePattern',
    defaultMessage: '{value} pattern',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoMovePatternLabel: {
    id: 'JobConfig.autoInfoAutoMovePatternLabel',
    defaultMessage: '(pattern={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoMovePatternRotateTrue: {
    id: 'JobConfig.autoInfoAutoMovePatternRotateTrue',
    defaultMessage: 'The pattern is rotated',
  },
  autoInfoAutoMovePatternRotateFalse: {
    id: 'JobConfig.autoInfoAutoMovePatternRotateFalse',
    defaultMessage: 'The pattern has normal orientation',
  },
  autoInfoAutoMoveTractorRotateTrue: {
    id: 'JobConfig.autoInfoAutoMoveTractorRotateTrue',
    defaultMessage: 'The tractor is rotated',
  },
  autoInfoAutoMoveTractorRotateFalse: {
    id: 'JobConfig.autoInfoAutoMoveTractorRotateFalse',
    defaultMessage: 'The tractor is in normal orientation',
  },
  autoInfoAutoMovePatternRotateLabel: {
    id: 'JobConfig.autoInfoAutoMovePatternRotateLabel',
    defaultMessage: '(isRotated={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  autoInfoAutoMoveTractorRotateLabel: {
    id: 'JobConfig.autoInfoAutoMoveTractorRotateLabel',
    defaultMessage: '(isTractorRotated={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  configInfoPatternSquare: {
    id: 'JobConfig.configInfoPatternSquare',
    defaultMessage: 'Square',
  },
  configInfoPatternTriangle: {
    id: 'JobConfig.configInfoPatternTriangle',
    defaultMessage: 'Triangle',
  },
  configInfoStatusTextOne: {
    id: 'JobConfig.configInfoStatusTextOne',
    defaultMessage: '{value} test skipped',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  configInfoStatusTextTwo: {
    id: 'JobConfig.configInfoStatusTextTwo',
    defaultMessage: '{value} feature Disabled',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  configInfoStatusTextThree: {
    id: 'JobConfig.configInfoStatusTextThree',
    defaultMessage: '{value} test was passed & enabled',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  configInfoStatusTextFour: {
    id: 'JobConfig.configInfoStatusTextFour',
    defaultMessage: '{value} test skipped, & enabled',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  configInfoStatusSecondaryText: {
    id: 'JobConfig.configInfoStatusSecondaryText',
    defaultMessage: '(status={value})',
    description: '"{value}" is a variable that is passed in, do not translate.',
  },
  organizationDoesNotExist: {
    id: 'JobInfo.organizationDoesNotExist',
    defaultMessage: "Organization doesn't exist?",
  },
  email: {
    id: 'JobInfo.email',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'JobInfo.emailPlaceholder',
    defaultMessage: 'Enter new user email...',
  },
  firstNamePlaceholder: {
    id: 'JobInfo.firstNamePlaceholder',
    defaultMessage: 'First name...',
  },
  firstName: {
    id: 'JobInfo.firstName',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'JobInfo.lastName',
    defaultMessage: 'Last Name',
  },
  lastNamePlaceholder: {
    id: 'JobInfo.lastNamePlaceholder',
    defaultMessage: 'Last Name...',
  },
  inviteUserDescription: {
    id: 'JobInfo.inviteUserDescription',
    defaultMessage: "Invite user you'd like to share report with.",
  },
  inviteAndShare: {
    id: 'JobInfo.inviteAndShare',
    defaultMessage: 'Invite',
  },
  organizationPlaceholder: {
    id: 'JobInfo.organizationPlaceholder',
    defaultMessage: 'Enter new organization name...',
  },
  fieldIsRequired: {
    id: 'JobInfo.fieldIsRequired',
    defaultMessage: 'This field is required!',
  },
  errorFetchingLogDataTitle: {
    id: 'JobInfo.errorFetchingLogDataTitle',
    defaultMessage: 'Error fetching log data',
  },
  youMustGoOnlineDescription: {
    id: 'JobInfo.youMustGoOnlineDescription',
    defaultMessage: 'You must go online to load this job log.',
  },
  waterPressureLabel: {
    id: 'WaterPressureGraph.waterPreassureLabel',
    defaultMessage: 'Water Pressure',
  },
  waterPressureDataEmpty: {
    id: 'WaterPressureGraph.waterPressureDataEmpty',
    defaultMessage: 'No Water Pressure Data Available',
  },
  clampPressureLabel: {
    id: 'ClampPressureGraph.clampPreassureLabel',
    defaultMessage: 'Clamp Pressure',
  },
  clampPressureDataEmpty: {
    id: 'ClampPressureGraph.clampPressureDataEmpty',
    defaultMessage: 'No Clamp Pressure Data Available',
  },
  inletPressureLabel: {
    id: 'InletPressureGraph.inletPressureLabel',
    defaultMessage: 'Inlet Pressure',
  },
  pressureLabelYAxis: {
    id: 'PressureGraph.pressureLabelYAxis',
    defaultMessage: 'Pressure ({value})',
    description: 'Label for axis that measures pressure. "{value}" is a variable that is passed in, do not translate.',
  },
  inletPressureDataEmpty: {
    id: 'InletPressureGraph.inletPressureDataEmpty',
    defaultMessage: 'No Inlet Preassure Data Available',
  },
  halfAverage: {
    id: 'JobInfo.halfAverage',
    defaultMessage: 'Half the Average',
  },
  average: {
    id: 'JobInfo.average',
    defaultMessage: 'Average',
  },
  twiceAverage: {
    id: 'JobInfo.twiceAverage',
    defaultMessage: 'Twice the Average',
  },
  oneAndAHalfAverage: {
    id: 'JobInfo.oneAndAHalfAverage',
    defaultMessage: '1.5 times the Average',
  },
  tripleAverage: {
    id: 'JobInfo.tripleAvailable',
    defaultMessage: 'Triple the Average',
  },
  syncTransferMessage: {
    id: 'JobInfo.syncTransferMessage',
    defaultMessage: 'Uploading {fileName} - {transferStatus}%',
    description: '"{fileName}" and "{transferStatus} are a variables that are passed in, do not translate.',
  },
  highPressureOnLegend: {
    id: 'JobInfo.highPressureOnLegend',
    defaultMessage: 'High Pressure On',
  },
  highPressureOffLegend: {
    id: 'JobInfo.highPressureOffLegend',
    defaultMessage: 'High Pressure Off',
  },
  controllerOffLegend: {
    id: 'JobInfo.controllerOffLegend',
    defaultMessage: 'Controller Off',
  },
  positioningLegend: {
    id: 'JobInfo.positioningLegend',
    defaultMessage: 'Positioning',
  },
  lanceFeedingLegend: {
    id: 'JobInfo.lanceFeedingLegend',
    defaultMessage: 'Lance Feeding',
  },
  idleLegend: {
    id: 'JobInfo.idleLegend',
    defaultMessage: 'Idle',
  },
  noHighPressureData: {
    id: 'JobInfo.noHighPressureData',
    defaultMessage: 'No High Pressure Time Data',
  },
  sentinelIdleVsPumpAtPressure: {
    id: 'JobInfo.sentinelIdleVsPumpAtPressure',
    defaultMessage: 'Sentinel Idle vs Pump at Pressure',
  },
  idleOff: {
    id: 'JobInfo.idleOff',
    defaultMessage: 'Idle/Off',
  },
  overlap: {
    id: 'JobInfo.overLap',
    defaultMessage: 'Overlap',
  },
  configurationTabTitle: {
    id: 'JobInfo.configurationTabTitle',
    defaultMessage: 'Configuration {configNumber}',
    description:
      'The title for one of many configuration tabs. {configNumber} is a number-typed variable passed in. For example: "Configuration 1" in English',
  },
  depthCleanedInfoTitle: {
    id: 'JobInfo.depthCleanedInfoTitle',
    defaultMessage: 'Depth Cleaned Heat Map',
  },
  depthCleanedInfoBody: {
    id: 'JobInfo.depthCleanedInfoBody',
    defaultMessage:
      'The depth cleaned heat map displays ranges of the lance depth in each tube while cleaning. This information can be helpful in identifying tubes that may not be cleaned as deeply. This may provide insight to any potential issues that can be addressed if the same tubes are not being cleaned as deeply as the others.',
  },
  autoStrokesInfoTitle: {
    id: 'JobInfo.autoStrokesInfoTitle',
    defaultMessage: 'Autostroke Heat Map',
  },
  autoStrokesInfoBody: {
    id: 'JobInfo.autoStrokesInfoBody',
    defaultMessage:
      'The autostroke heat map displays tubes that had or did not have autostroke events occur during cleaning. This information can be helpful in identifying tubes that may have blockages.',
  },
  lanceSpeedInfoTitle: {
    id: 'JobInfo.lanceSpeedInfoTitle',
    defaultMessage: 'Lance Speed Heat Map',
  },
  lanceSpeedInfoBody: {
    id: 'JobInfo.lanceSpeedInfoBody',
    defaultMessage:
      'The lance speed heat map displays ranges of the speed that the lance traveled while cleaning in the tube. This information can be helpful in identifying tubes that may not be cleaned as quickly as others. This may provide insight to any potential issues that can be addressed if the same tubes aren’t being cleaned as quickly as the others.',
  },
  updateJobDetails: {
    id: 'JobInfo.updateJobDetails',
    defaultMessage: 'Update Job Details',
  },
  updateDetailsSuccess: {
    id: 'JobInfo.updateDetailsSuccess',
    defaultMessage: 'Details updated successfully',
  },
  updateDetailsFailure: {
    id: 'JobInfo.updateDetailsFailure',
    defaultMessage: 'Error updated job details. Please try again',
  },
  completeJobDialogTitle: {
    id: 'JobInfo.completeJobDialogTitle',
    defaultMessage: 'Complete Job?',
  },
  completeJobDialogDescription: {
    id: 'JobInfo.completeJobDialogDescription',
    defaultMessage:
      'Completing a job that is still in progress could interfere with the accuracy of recording job data. Once you complete a job, you cannot undo this action.',
  },
  completeJobButtonLabel: {
    id: 'JobInfo.completeJobButtonLabel',
    defaultMessage: 'COMPLETE',
  },
  jobGraphIdleVsHpLabelHp: {
    id: 'IdleVsHp.labelHp',
    defaultMessage: 'High Pressure',
  },
  jobGraphIdleVsHpLabelIdle: {
    id: 'IdleVsHp.labelIdle',
    defaultMessage: 'Idle',
  },
  jobGraphIdleVsHpLabelOverlap: {
    id: 'IdleVsHp.labelOverlap',
    defaultMessage: 'Potential waste of fuel/water',
  },
  endOfJobsListMessage: {
    id: 'JobsList.endOfJobsListMessage',
    defaultMessage:
      'You have loaded the maximum number of job logs supported. If a job log is not present, please adjust the search filters.',
  },
  endOfResultsMessage: {
    id: 'JobsList.endOfResultsMessage',
    defaultMessage: 'End of job logs matching the search filters.',
  },
  bundlesTitle: {
    id: 'JobList.bundlesTitle',
    defaultMessage: 'Bundles',
  },
  jobsTitle: {
    id: 'JobList.jobsTitle',
    defaultMessage: 'Jobs',
  },
  logsTitle: {
    id: 'JobList.logsTitle',
    defaultMessage: 'Logs',
  },
  cannotUploadJobLogMessage: {
    id: 'JobList.cannotUploadJobLogMessage',
    defaultMessage: 'The connected controller belongs to another organization, you cannot upload a log from it.',
  },
  jobTip: {
    id: 'JobList.jobTip',
    defaultMessage: 'Tip',
  },
  jobLiveNow: {
    id: 'JobList.jobLiveNow',
    defaultMessage: 'Live Now',
  },
});
